export class IHistory {
  identifier: string;
  name: string;
  quantity: number;
  orderTime: string;
  subIdentifier: string;
  price: number;
  rowTotalPrice: number;
  isHaizen: string;
}
export class HistoryDTO implements IHistory {
  identifier: string;
  name: string;
  quantity: number;
  orderTime: string;
  subIdentifier: string;
  price: number;
  rowTotalPrice: number;
  isHaizen: string;
}

export default class History extends HistoryDTO {
  constructor(dto?: HistoryDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      identifier: "",
      name: "",
      quantity: 0,
      orderTime: "",
      subIdentifier: "0",
      price: 0,
      rowTotalPrice: 0,
      isHaizen: ""
    });
  }
}
